import { jsx as _jsx } from "react/jsx-runtime";
import { getTemplate, localToUTC, utcToLocal, } from '@rjsf/utils';
export default function DateTimeWidget(props) {
    const { registry } = props;
    const uiProps = props.options['props'] || {};
    const options = {
        ...props.options,
        props: {
            type: 'datetime-local',
            ...uiProps,
        },
    };
    const BaseInputTemplate = getTemplate('BaseInputTemplate', registry, options);
    const value = utcToLocal(props.value);
    const onChange = (value) => {
        props.onChange(localToUTC(value));
    };
    // TODO: rows and columns.
    return _jsx(BaseInputTemplate, { ...props, options: options, value: value, onChange: onChange });
}
//# sourceMappingURL=DateTimeWidget.js.map